import { c as _c } from "react/compiler-runtime";
import { usePathname } from "@opensea/navigation";
import { useAccountStates } from "@opensea/wallet";
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from "@/constants/constants";
import { AccountBannedPage } from "./AccountBannedPage";
export function AccountBannedGuard(t0) {
  const $ = _c(1);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const accountStates = useAccountStates();
  if ([PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL].includes(pathname)) {
    return children;
  }
  if (accountStates.length === 0) {
    return children;
  }
  const restrictedStates = ["STATE_100", "STATE_200", "STATE_300", "STATE_500"];
  if (!accountStates.some(state => restrictedStates.includes(state))) {
    return children;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AccountBannedPage />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
}